export enum textShadow {
  base = '0px 1px 2px rgba(0, 0, 0, 0.3)',
}
